import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import si from './locales/si.json';
import ta from './locales/ta.json';
import { flattenTranslations } from './flattenTranslations';
import { LANGUAGE_STORAGE_KEY, normalizeAppLanguage } from './constants';

function loadInitialLanguage(): 'si' | 'ta' | 'en' {
  try {
    const raw = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return normalizeAppLanguage(raw);
  } catch {
    return 'en';
  }
}

const resources = {
  en: { translation: flattenTranslations(en) },
  si: { translation: flattenTranslations(si) },
  ta: { translation: flattenTranslations(ta) },
};

if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    resources,
    lng: loadInitialLanguage(),
    supportedLngs: ['en', 'si', 'ta'],
    fallbackLng: 'en',
    defaultNS: 'translation',
    keySeparator: false,
    nsSeparator: false,
    interpolation: { escapeValue: false },
    returnEmptyString: false,
    react: {
      useSuspense: false,
    },
  });
}

export { i18n };
